import { Component } from '@angular/core';

@Component({
  selector: 'app-form-footer',
  imports: [],
  templateUrl: './form-footer.html',
  styleUrl: './form-footer.scss',
})
export class FormFooter {
}
